import { useEffect, useState } from 'react';
import { API, Auth } from 'aws-amplify';
import { useHistory } from 'react-router';
import { setSystem } from '../store/system';

export function PolicyAuth(props) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const history = useHistory();

  useEffect(() => {
    Auth.currentCredentials()
      .then(async (info) => {
        const { identityId: IdentityId } = info;

        if (!IdentityId) {
          await Auth.signOut();
          history.push('/');

          // TODO: We need to have a global method that cleans up the global store upon logout
          // For now, we will just reset the system state
          setSystem(null);

          throw new Error('Could not find IdentityId');
        }

        try {
          await API.post('IO_API', `/auth/iot-policy`, { body: { IdentityId } });

          setError(null);
          setLoading(false);
        } catch (err) {
          console.log('ERROR', err);
          setLoading(false);
          setError(`ERROR ${err}`);
        }
      })
      .catch((err) => {
        setLoading(false);
        setError(`ERROR ${err}`);
        console.log('GET INFO ERROR', err);
      });
    setLoading(false);
  }, []);

  if (loading) {
    return <div>Validating user access permissions . . .</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return <>{props.children}</>;
}
